'use client'

import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'
import { getSlugData } from '../utils'
import { useBoolean, useList, useLocalStorage, useWindowScroll, useWindowSize } from 'react-use'
import { HOUSE_LIST_VIEWED_IDS_KEY } from '@config'
import useMapData from './useMapData'
import { toNumber } from '@utils'
import { find, get } from 'lodash-es'

export const HouseListContext = createContext()
export function useHouseListContext() {
  return useContext(HouseListContext)
}

export default function HouseListContextProvider({
  state,
  children
}) {

  // showmap
  const houseRoute = getSlugData(state.slug)
  const showMap = houseRoute.mapVisible()

  // 是否全屏显示地图
  const [fullMap, toggleFullMap] = useBoolean(false)

  // search bar height
  const [searchBarHeight, setSearchBarHeight] = useState(0)
  // map height
  const [mapHeihgt, setMapHeight] = useState(0)
  // map container ref
  const mapwrapRef = useRef(null)

  // ===============================地图数据相关==================================
  // 地图上点击过的marker ids
  const [viewedIds, setViewedIds] = useLocalStorage(HOUSE_LIST_VIEWED_IDS_KEY, [])
  // 鼠标当前悬浮的房源
  const [hoverData, setHoverData] = useState()
  // 鼠标当前悬浮的房源详情数据
  const [hoverDetailData, setHoverDetailData] = useState()

  // 当前地图渲染的marker
  const [markerList, { reset: resetMarkerList, push: pushMarker }] = useList([])
  // 地图范围
  const [bounds, setBounds] = useState()
  const [rect, setRect] = useState()
  // map data
  const mapDataState = useMapData({ resetMarkerList, bounds, rect, state, fullMap })

  // 根据当前hover的房源，展开marker popup
  useEffect(() => {
    const id = toNumber(get(hoverData, 'id'))
    const marker = find(markerList, item => get(item, 'data.combineIds', []).includes(id))
    if (marker) {
      const popup = marker.getPopup()
      if (!popup.isOpen()) {
        marker.togglePopup()
      }
      marker.setHoverData(hoverData)
      marker.getElement().style.zIndex = 1
    }
    return () => {
      if (marker) {
        const popup = marker.getPopup()
        if (popup.isOpen()) {
          marker.togglePopup()
        }
        marker.setHoverData()
        marker.getElement().style.zIndex = ''
      }
    }
  }, [hoverData, markerList])

  // 地图数据加载
  const mapLoadData = useCallback(map => {
    const bounds = map.getBounds()
    const ne = bounds.getNorthEast()
    const sw = bounds.getSouthWest()
    setRect([sw.lng, ne.lng < 0 ? 180 : ne.lng, sw.lat, ne.lat])
    setBounds(bounds)
  }, [setRect, setBounds])
  // 添加已查看id
  const pushViewedId = useCallback(id => {
    // 暂时屏蔽已查看功能
    // if (viewedIds.includes(toNumber(id))) return
    // viewedIds.push(toNumber(id))
    // setViewedIds([...viewedIds])
    // }, [setViewedIds, viewedIds])
  }, [])

  // 计算map height
  const { x, y } = useWindowScroll()
  const { width, height } = useWindowSize()
  useEffect(() => {

    if (!showMap || !mapwrapRef.current) return

    const { top } = mapwrapRef.current.getBoundingClientRect()
    const fullHeight = window.innerHeight - (window.scrollY + top)
    const topHeight = window.innerHeight - fullHeight
    const listHeight = document.getElementById('house-wrap').offsetHeight
    setMapHeight(window.scrollY > topHeight ? window.innerHeight : Math.min(listHeight, fullHeight + window.scrollY))

    const searchBar = document.getElementById('search-bar')
    if (searchBar) {
      const bound = searchBar.getBoundingClientRect()
      setSearchBarHeight(bound.y <= 0 ? bound.height : 0)
    }
  }, [mapwrapRef, showMap, setMapHeight, setSearchBarHeight, x, y, width, height, mapDataState.isLoading])

  return (
    <HouseListContext.Provider value={{
      rect,
      state,
      showMap,
      mapHeihgt,
      mapwrapRef,
      fullMap,
      searchBarHeight,
      toggleFullMap,
      // 地图数据相关
      ...mapDataState,
      viewedIds,
      hoverData,
      hoverDetailData,
      setHoverData,
      setHoverDetailData,
      pushMarker,
      mapLoadData,
      pushViewedId
    }}>
      {children}
    </HouseListContext.Provider>
  )
}